var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-switch-btn",class:[_vm.isTurnOn ? 'toggleBg' : ''],on:{"click":_vm.handleSwitch}},[_c('div',{staticClass:"ball",class:[_vm.isTurnOn ? 'toggleLeft' : '']})])}
var staticRenderFns = []

export { render, staticRenderFns }